import type { ReactNode } from "react";

interface ShareWhiteboardFieldGroupProps {
	children: ReactNode;
}

export function ShareWhiteboardFieldGroup(
	props: ShareWhiteboardFieldGroupProps,
) {
	return (
		<div className="flex flex-col gap-2 mb-1 sm:flex-row sm:items-end sm:h-14 mt-2 sm:mt-[-0.625rem]">
			{props.children}
		</div>
	);
}
